// ENSURE THESE MATCH MIKASA!!
// TODO - Let mikasa drive this
export const DEFAULT_MAX_BUDGET = 1500
export const DEFAULT_CURRENT_MONTHLY_COST = 1500
export const DEFAULT_DOWN_PAYMENT = 30000
export const DEFAULT_YEARS_IN_HOME = 7
export const DEFAULT_RENTABLE_NIGHTS = 6

export const MIN_YEARS_IN_HOME = 1
export const MAX_YEARS_IN_HOME = 30

export const MIN_RENTABLE_NIGHTS = 0
export const MAX_RENTABLE_NIGHTS = 31

export const BUDGET_PRICE_POINT_RATIO = 0.005

export const BUYER_PREQUAL_PROMPT = 'buyer-prequal-prompt'

export const OWNER_CLIENT_TYPE = 'homeowner'
export const RENTER_CLIENT_TYPE = 'renter'
export const GUEST_CLIENT_TYPE = 'guest'

export const BUYER_DOWN_PAYMENT_PERCENT_OF_LISTING_PRICE = 0.07
export const BUYER_DOWN_PAYMENT = 7
export const OWNER_DOWN_PAYMENT_PERCENT_OF_LISTING_PRICE = 0.22
export const OWNER_DOWN_PAYMENT = 22

export const OWNER_TYPES = [OWNER_CLIENT_TYPE]
export const RENTER_TYPES = [RENTER_CLIENT_TYPE]
export const GUEST_TYPES = [GUEST_CLIENT_TYPE]

export const PMI_DROPPED_PERCENT = 22
export const PMI_DROPPED_PERCENT_AS_DECIMAL = PMI_DROPPED_PERCENT / 100.0
